<ion-header class="ion-no-shadow ion-no-border ion-hide-xl-up">
    <ion-toolbar>
        <a (click)="logout()"
           class="back-link">
            <svg-icon [applyClass]="true"
                      src="/assets/icons/ico-arrow.svg"></svg-icon>

        </a>
        <ion-title>{{ 'NO_EVENT' | trns }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">

    <header-notifications></header-notifications>

    <div class="content-box black-header">

        <div class="content-box-inner">
            <div class="content-data">
                <div class="empty-data">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-calendar.svg"
                              class="icon fill-light"></svg-icon>
                    <h3>{{ 'NO_EVENT' | trns }}</h3>
                    <p>
                        {{ 'NO_EVENT_DESCRIPTION' | trns }}
                    </p>

                    <h3>{{ 'USE_EVENT_KEY' | trns }}</h3>
                    <p>{{ 'EVENT_KEY_HINT' | trns }}</p>

                    <form method="get"
                          #f="ngForm"
                          role="form"
                          (ngSubmit)="useEventKey()"
                          class="form-horizontal">

                        <ion-row class="ion-no-padding">
                            <ion-col size="10"
                                     offset="1"
                                     size-md="4"
                                     offset-md="4"
                                     class="ion-no-padding">
                                <ion-item [ngClass]="{ 'has-error': validate && validationErrors['event_key'] }">
                                    <ion-input type="text"
                                               name="event_key"
                                               inputmode="text"
                                               spellcheck="false"
                                               autocapitalize="off"
                                               #event_key="ngModel"
                                               [(ngModel)]="eventKey">
                                    </ion-input>
                                </ion-item>
                                <span *ngIf="validate && validationErrors['event_key']"
                                      class="error-message">
                                    {{ validationErrors['event_key'] }}
                                </span>
                                <span *ngIf="event_key.touched && !event_key.valid"
                                      class="error-message">
                                    {{ 'VALIDATION_EVENT_KEY' | trns }}
                                </span>
                                <ion-button color="primary"
                                            [disabled]="submit || !eventKey"
                                            (click)="useEventKey()">
                                    {{ 'BUTTON_USE_EVENT_KEY' | trns }}
                                </ion-button>
                            </ion-col>
                        </ion-row>


                    </form>

                    <ion-button (click)="openDestroyAccount()"
                                color="danger"
                                margin-top
                                fill="clear">
                        {{ 'PROFILE_EDIT_DELETE_ACCOUNT' | trns }}
                    </ion-button>
                </div>
            </div>
        </div>
    </div>

</ion-content>